<template>
  <button :class="this.customColor+' button button-primary'+(this.fullWidth?' full-width':'')"
          :disabled="!!this.disabled"
  >
    {{ text }}
  </button>
</template>

<style>
button.button-primary.green {
  background-color: var(--success);
  border-color: var(--success);
}
</style>

<script>
export default {
  props: [
    "text",
    "customColor",
    "disabled",
    "fullWidth",
  ],
}
</script>